import { useState, useContext, useEffect, useCallback } from "react";
import { MainContext } from "../../context/main-context";
import { getMapservice, getRequest } from "../../api/vallaris/mapservice";

const UseMapserviceV = () => {
  const [mapservices, setmapservices] = useState<object | null>(null);
  const { hostV, apikeyV, tokenV, userIdV } = useContext(MainContext);

  const loadMs = useCallback(async () => {
    let fullMsLayer = new Array();
    const mapserviceLayer = await getMapservice(
      hostV,
      apikeyV,
      tokenV,
      userIdV
    );
    if (mapserviceLayer.length) {
      const promisLayers = await mapserviceLayer.map((layer: any) => {
        return getRequest(hostV, apikeyV, tokenV, userIdV, layer.layer_id);
      });
      const reqLayers = await Promise.all(promisLayers);
      await reqLayers.map((rl: any) => {
        const getMapRqList = rl.filter(
          (r: any) =>
            r.request_type === "GET_MAPTILE" || r.request_type === "GET_MAP"
        );
        const layer = mapserviceLayer.find(
          (l: any) => l.layer_id === getMapRqList[0].layer_id
        );
        fullMsLayer.push({
          ...layer,
          request: getMapRqList.length ? getMapRqList[0] : null
        });
        return rl;
      });
    }

    setmapservices(fullMsLayer);
  }, []);

  useEffect(() => {
    if (!mapservices) {
      loadMs();
    }
  }, [mapservices, loadMs]);

  return mapservices;
};

export default UseMapserviceV;
